// ------------------------------------------------------------------------------------------- //
// --------------------------- Watch the Class - Listen to Change  ----------------------------
// ------------------------------------------------------------------------------------------- //

export class ClassWatcher {

    // on class construct, define variables
    constructor(targetNode, classToWatch, classAddedCallback, classRemovedCallback) {
        console.log(classToWatch);
        this.targetNode = targetNode
        this.classToWatch = classToWatch
        this.classAddedCallback = classAddedCallback
        this.classRemovedCallback = classRemovedCallback
        this.observer = null
        this.lastClassState = (targetNode) ?  targetNode.classList.contains(this.classToWatch) : null;

        // if(!this.lastClassState) {
        //     return;
        // }

        this.init()
    }

    // Listen to the initiation and register a new mutation observer
    init() {
        this.observer = new MutationObserver(this.mutationCallback)
        this.observe()
    }

    // Listen to the target node
    observe() {
        this.observer.observe(this.targetNode, { attributes: true })
    }

    // Stop listening to the target node
    disconnect() {
        this.observer.disconnect()
    }

    // Callback for the mutation observer
    mutationCallback = mutationsList => {
        for(let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                let currentClassState = mutation.target.classList.contains(this.classToWatch)
                if(this.lastClassState !== currentClassState) {
                    this.lastClassState = currentClassState
                    if(currentClassState) {
                        this.classAddedCallback()
                    }
                    else {
                        this.classRemovedCallback()
                    }
                }
            }
        }
        
    }
}